export { default as SupportPage } from './Support'
